// removed by extract-text-webpack-plugin
module.exports = {"block":"_3L2M1sjq2M0S5u5xMHtGo5","container":"_1HGFRtJr_XUGRaJx9_bfa0","no-logo":"K8rZ7CdxqYLFiVtBijzeC","logo-container":"_11DijMUTEVCu8u8btpeQP_","logo":"_3VVrBBlEgRJez5nJcfNRHS","text-container":"_3kF_kS_j6tDpIwizOa6NSP","name":"_1CmqDzXM7dWtetYJjILiiM","container-no-logo":"_3yVdMZ0TJyX9H6Bz2dJ4c5","button":"_3YYzqF1YVSCDWbuh_a41"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VisitOurWebsiteBlock/VisitOurWebsiteBlock.module.scss
// module id = 818
// module chunks = 0